import { composeIO } from 'react-compose-io'
import { tabelaCicloIO } from './TabelaCiclo.IO'
import { TabelaCicloView } from './TabelaCiclo.View'

export const TabelaCiclo = composeIO(TabelaCicloView, tabelaCicloIO)
